import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {DocumentTemplateModel} from '../../../api/entity/documentTemplate.model';
import {DocumentTemplateConverter} from '../../../api/entity/converter/documentTemplate.converter';
import {AbstractDataServiceV2} from '../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';

@Injectable({
    providedIn: 'root'
})
export class DocumentTemplateDataService extends AbstractDataServiceV2<DocumentTemplateModel, DocumentTemplateConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: DocumentTemplateConverter) {
        super('DocumentTemplate', http, httpUrlGenerator, logger, config, converter);
    }
}
